import { DialogContent, styled } from "@mui/material";

export const CloudDialogContent = styled(DialogContent)(() => ({
  padding: "16px 24px",
  height: "content-fit",
}));
